module.exports = __webpack_public_path__ + "static/media/user-tie.f2016254.svg";